import * as actionTypes from './actionTypes'

type BasePayloadType = { sourceType: string }

export type StartedPayloadType = BasePayloadType
export const started = ({ sourceType }: StartedPayloadType) => ({
  type: actionTypes.STARTED,
  meta: { sourceType },
})

export type SucceededPayloadType = BasePayloadType & { payload: any }
export const succeeded = ({ sourceType, payload }: SucceededPayloadType) => ({
  type: actionTypes.SUCCEEDED,
  meta: { sourceType },
  payload,
})

export type FailedPayloadType = BasePayloadType & { error: any }
export const failed = ({ sourceType, error }: FailedPayloadType) => ({
  type: actionTypes.FAILED,
  meta: { sourceType },
  error: error || true,
})

export type EndedPayloadType = BasePayloadType
export const ended = ({ sourceType }: EndedPayloadType) => ({
  type: actionTypes.ENDED,
  meta: { sourceType },
})

export const clearError = () => ({
  type: actionTypes.CLEAR_ERROR,
})
